module.exports = __webpack_public_path__ + "img/arrow-down.74343806.svg";